import { acceptHMRUpdate, defineStore } from "pinia"

export const useStoryblokStore = defineStore("storyblok", () => {
  const storyapi = useStoryblokApi()

  // *******************************************************
  // VERSION
  // *******************************************************
  const config = useRuntimeConfig()
  const version = ref(config.public.SB_VERSION || "draft")

  // *******************************************************
  // DATA SOURCES
  // *******************************************************
  const datasources = reactive({
    expertises: null,
    languages: null,
  })

  const initDataSources = async function () {
    const ps = []
    for (const key of Object.keys(datasources)) {
      const p = storyapi
        .getAll(`cdn/datasource_entries`, {
          datasource: key,
          version: version.value,
        })
        .then((val) => {
          datasources[key] = val
        })

      ps.push(p)
    }
    await Promise.all(ps)
    return datasources
  }

  return {
    version,

    datasources,
    initDataSources,
  }
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useStoryblokStore, import.meta.hot))
